<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div class="flex w-full gap-1">
    <i :class="iconClass" class="mr-2 text-2xl" aria-hidden="true"></i>
    <div class="flex flex-column flex-grow-1 gap-1">
      <div class="text-base font-bold">{{ summary }}</div>
      <div class="text-base">
        <template v-if="link">
          {{ messageBeforeLink }}
          <a :href="link" class="underline" target="_blank" rel="noopener">{{
            linkText
          }}</a>
          {{ messageAfterLink }}
        </template>
        <template v-else>
          <div>{{ message }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomToastContent",
  props: {
    severity: {
      type: String,
      default: "info", //error | success | secondary | info | contrast | warn
    },
    summary: {
      type: String,
      default: "Info",
    },
    link: {
      type: String,
      default: "",
    },
    linkText: {
      type: String,
      default: "Cliquez ici",
    },
    messageBeforeLink: {
      type: String,
      default: "",
    },
    messageAfterLink: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "Voici un message sans lien.",
    },
  },
  computed: {
    iconClass() {
      switch (this.severity) {
        case "success":
          return "ri-check-line text-success";
        case "info":
          return "ri-information-line text-info";
        case "warn":
          return "ri-alert-line text-warning";
        case "error":
          return "ri-close-circle-line text-danger";
        default:
          return "ri-information-line text-info";
      }
    },
  },
};
</script>
